import axiosClient from '@/api/axiosClient';
import { API_GET_WHEEL, API_UPDATE_WHEEL } from '@/config/paths/API_PATH';

async function getWheelList(payload) {
  const { data } = await axiosClient.get(API_GET_WHEEL, {
    params: payload,
  });

  return data;
}

async function updateWheel(payload) {
  const { data } = await axiosClient.post(API_UPDATE_WHEEL, {
    ...payload,
  });

  return data;
}

export { getWheelList, updateWheel };
